import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Option {
  icon: string
  label: string
  value: string
  secondLabel: string
}

interface useFormLabelsProps {
  transferWalletOptions: Option[]
  isCustomerWalletTransferType: boolean
}

export const useFormLabels = ({
  transferWalletOptions,
  isCustomerWalletTransferType,
}: useFormLabelsProps) => {
  const { t } = useTranslation()

  const selectBeneficiaryDropdownPlaceholder = useMemo(() => {
    if (!!transferWalletOptions && !transferWalletOptions?.length) {
      return t('customers.noWalletsAvailable')
    } else {
      return t('customers.walletSelect')
    }
  }, [transferWalletOptions])

  const destinationWalletLabel = useMemo(() => {
    if (isCustomerWalletTransferType) {
      return t('customers.selectCustomerWallet')
    }

    return t('selectWallet')
  }, [isCustomerWalletTransferType])

  return {
    selectBeneficiaryDropdownPlaceholder,
    destinationWalletLabel,
  }
}
